var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle33ASelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 51 48",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M13.293 3.274A2.5 2.5 0 0 1 15.783 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6A2.5 2.5 0 0 1 21.762 12h-6.524a2.5 2.5 0 0 1-2.49-2.726l.545-6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M15.238 2c-.686 0-1.314.388-1.62 1.002l-.223.445a1 1 0 1 1-1.79-.894l.223-.446A3.813 3.813 0 0 1 15.238 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 1 1-1.79.894l-.222-.445A1.812 1.812 0 0 0 21.762 2h-6.524Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M34.498 33h-31a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5h31a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M50 44.5V10l-7.251-.725A2.5 2.5 0 0 0 40 11.762V34.5a2.5 2.5 0 0 1-2.5 2.5H3.977A2.5 2.5 0 0 0 1.5 39.834l.97 7.164L47.5 47a2.5 2.5 0 0 0 2.5-2.5Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M50 8a1 1 0 0 1 1 1v35.5a3.5 3.5 0 0 1-3.5 3.5H1a1 1 0 1 1 0-2h46.5a1.5 1.5 0 0 0 1.5-1.5V9a1 1 0 0 1 1-1Z",
  clipRule: "evenodd"
})));
SvgRectangle33ASelected.viewBox = '0 0 51 48';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle33ASelected);
export default ForwardRef;